






























































































































































import Component from 'vue-class-component';
import { Vue, Prop, Watch } from 'vue-property-decorator';
import {
  ChargeStatus,
  gisGmpStatuses,
} from '@/modules/HuntingLicenses/LicenseOrder/licences.constants';
import ConfirmModal from '@/shared_components/ConfirmModal.vue';

@Component({
  name: 'ChargeInfo',
})
export default class ChargeInfo extends Vue {
  @Prop({ type: Object, required: true })
  charge!: Orders.GisGmpChargeFull;

  @Prop({ default: false, type: Boolean })
  loading!: boolean;

  gisGmpStatuses = gisGmpStatuses;

  showCancelDescription: boolean = false;

  showCheckDescription: boolean = false;

  @Watch('charge')
  watchCharge(n, o) {
    if (n.id !== o.id) {
      this.reset();
    }
  }

  private reset() {
    console.debug('reseting ...');
    this.showCheckDescription = false;
    this.showCancelDescription = false;
  }

  get canBeAnnulated() {
    return ![ChargeStatus.canceled, ChargeStatus.canceling, ChargeStatus.error].includes(
      this.charge.status
    );
  }

  get canBeChecked() {
    return ![ChargeStatus.canceled, ChargeStatus.canceling, ChargeStatus.error].includes(
      this.charge.status
    );
  }

  cancel() {
    this.$q
      .dialog({
        component: ConfirmModal,
        parent: this,
        headerText: 'Подтверждение аннулирования начисления',
        text:
          'Пожалуйста подумайте еще раз стоит ли аннулировать начисление, ЕПГУ принимает информацию о начислении по заявлению только один единственный раз',
        confirmLabel: 'Да, хочу аннулировать',
        cancelLabel: 'Нет, я передумал',
      })
      .onOk(() => {
        const done = () => {
          this.showCancelDescription = true;
        };
        this.$emit('cancel', { charge: this.charge, done });
      });
  }

  refresh() {
    this.$emit('refresh', this.charge);
  }

  check() {
    const done = () => {
      console.debug('Checking done.');
      this.showCheckDescription = true;
    };
    this.$emit('check', { charge: this.charge, done });
  }

  mounted() {
    this.reset();
  }
}
